import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import Header from "@/components/marketing/Header";
import HeroSection from "@/components/marketing/HeroSection";
import AboutSection from "@/components/marketing/AboutSection";
import AppsSection from "@/components/marketing/AppsSection";
import MediaSection from "@/components/marketing/MediaSection";
import ContactSection from "@/components/marketing/ContactSection";
import Footer from "@/components/marketing/Footer";

export default function MarketingSite() {
  const [apps, setApps] = useState([]);
  const [media, setMedia] = useState([]);

  useEffect(() => {
    api.getApps().then(setApps).catch(console.error);
    api.getMedia().then(setMedia).catch(console.error);
  }, []);

  return (
    <div className="min-h-screen bg-[#05050A]" data-testid="marketing-site">
      <Header />
      <HeroSection />
      <AboutSection />
      <AppsSection apps={apps} />
      <MediaSection media={media} />
      <ContactSection />
      <Footer />
    </div>
  );
}
